// Where the editor's ways out go: the project list and the Library in the UI the person chose,
// Pro's when the remembered choice is Pro, else Classic's (spec
// ui-perf/ui-switch-classic-simple-pro, PR e6, decision 13). The editor's own URLs are the same in
// both.
import type { PrefValue } from "../../platform/prefs";

type Ui = PrefValue<"ui">;

/** The brand's edit projects, in the chosen UI. */
export function projectsIn(ui: Ui) {
  return ui === "pro"
    ? ("/teams/$teamId/brands/$brandId/home2/editor" as const)
    : ("/teams/$teamId/brands/$brandId/editor" as const);
}

/** The brand's Library, in the chosen UI: Pro's is the Library's own view inside Pro. */
export function libraryIn(ui: Ui) {
  return ui === "pro"
    ? ("/teams/$teamId/brands/$brandId/home2/library/files" as const)
    : ("/teams/$teamId/brands/$brandId/library" as const);
}
